import { forOwn, pickBy, includes, findIndex } from 'lodash';

export const buildUser = (general, express) => {
    const callServices = ['Local', 'National', 'International', 'InterPBX', 'Mobile', 'Special', 'Emergency'];
    const booleanValues = ['ExtensionOnMobileEnabled', 'ExtensionOnWebEnabled', 'UseSecurityPin', 'UseVoicemail', 'Monitor'];
    const bannedKeys = [
        'EnableSecurityPIN',
        'RepeatedPassword',
        'ShowPassword',
        'ShowRepeatedPassword',
        'ShowSecurityPIN',
        'Edition'
    ];

    const curatedExpressConfiguration = {};
    const noBannedKeys = pickBy({ ...express }, (value, key) =>
        key === 'ExtensionPassword' && !value ? false : !includes(bannedKeys, key)
    );

    forOwn(noBannedKeys, (value, key) => {
        let formattedValue = value;

        if (includes(callServices, key)) {
            formattedValue = findIndex(value, callServiceValue => callServiceValue).toString();
        } else if (includes(booleanValues, key)) {
            formattedValue = (+value).toString();
        } else if (key === 'Extension') {
            formattedValue = +value;
        } else if (key === 'Profiles' && value === 'local') {
            formattedValue = [""];
        } else if (key === 'Profiles') {
            formattedValue = [value];
        }

        curatedExpressConfiguration[key] = formattedValue;
    });

    return {
        ...general,
        ...curatedExpressConfiguration
    };
};
